import { render, staticRenderFns } from "./AssetsDevicesForm.vue?vue&type=template&id=f5dad5fa&"
import script from "./AssetsDevicesForm.vue?vue&type=script&lang=js&"
export * from "./AssetsDevicesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports